import { Activity, AlertCircle, ClipboardList, Shield } from "lucide-react";
import type { AuditSummary } from "../types";

const CARD_BORDER = "hsl(210,30%,85%)";

type Card = {
  label: string;
  value: number;
  icon: typeof Activity;
  tint: string;
  fg: string;
};

export function AuditSummaryCards({ summary }: { summary: AuditSummary }) {
  const cards: Card[] = [
    {
      label: "Total Events",
      value: summary.totalEvents,
      icon: ClipboardList,
      tint: "hsl(210,30%,96%)",
      fg: "hsl(215,16%,40%)",
    },
    {
      label: "System Activity",
      value: summary.systemActivity,
      icon: Activity,
      tint: "hsl(210,55%,92%)",
      fg: "hsl(210,100%,28%)",
    },
    {
      label: "Security Events",
      value: summary.securityEvents,
      icon: Shield,
      tint: "hsl(38,92%,92%)",
      fg: "hsl(38,92%,30%)",
    },
    {
      label: "Failures",
      value: summary.failures,
      icon: AlertCircle,
      tint: "hsl(0,84%,95%)",
      fg: "hsl(0,72%,45%)",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {cards.map((c) => (
        <div
          key={c.label}
          className="flex items-center gap-3 rounded-xl border bg-card p-4"
          style={{ borderColor: CARD_BORDER }}
        >
          <div
            className="flex h-9 w-9 items-center justify-center rounded-md"
            style={{ background: c.tint, color: c.fg }}
          >
            <c.icon className="h-4 w-4" strokeWidth={1.5} />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-wide text-muted-foreground">
              {c.label}
            </div>
            <div className="text-xl font-semibold text-foreground">
              {c.value.toLocaleString()}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
